
module Meevo.Convo {
    "use strict";

    class ConvoBarController {

        private convoPlaceholder: string;
        private convoService: IConvoService;
        private convoInput: string;
        private debouncedHandler: any;
        private isSingleLocation: boolean;
        private inCentralOfficeMode: boolean;
        private inSandboxMode: boolean;
        private isMSIUser = false;
        private isConvoInvalid = false;
        private isTrainingEnvironment = false;
        private isTestingEnvironement = false;
        private convoTimeout = 2000;
        private $timeout: ng.ITimeoutService = null;
        private inCallCenterMode: boolean;
        private isClickListenerAdded = false;
        private isConvoPending = false;
        // Resolved asynchronously so the raw key never flashes before the translation table loads.
        private enhancedPlaceholder: string = '';

        public enableConvobarAppointmentSuggestions: boolean;
        public EmployeeDoesNotPerformService = false;
        public EmployeeDoesNotPerformServiceMessage = "";
        public suggestedCommands: ISuggestedConvoCommand[] = null;
        public restingShortcut: string = '';
        public embeddings: number[] = [];
        public rootScope: ng.IRootScopeService;
        public scope: ng.IScope;
        private reportList: Meevo.Model.IReport[] = [];

        public get alertsCount(): number {
            return this.alertsLogService.alertsCount;
        }

        public get hideConvobarHelpIcon(): boolean { return (window as any).hideConvobarHelpIcon; }

        // When the enhanced global nav is on, this legacy convobar only renders inside the
        // enhanced navbar's phone dropdown — its hidden #convobar_help would duplicate the
        // enhanced nav's Pendo anchor id and shadow Pendo's selector matching.
        public get isEnhancedGlobalNav(): boolean {
            return !!(this.appSettings.APP_BUSINFOSETTINGS
                && this.appSettings.APP_BUSINFOSETTINGS.generalSettings
                && this.appSettings.APP_BUSINFOSETTINGS.generalSettings.enableEnhancedGlobalNavigation);
        }

        static $inject = ['meevo.convo.ConvoService', '$scope', '$rootScope', '$timeout', 'meevo.components.common.IdentityService', 'meevo.components.modal.ModalService', 'meevo.components.common.DataService', '$translate', 'meevo.plugins.alertsLog.AlertsLogService', 'meevo.menuService', '$document', 'meevo.AppSettings', 'meevo.components.common.SecurityService', '$q'];

        constructor(convoService: IConvoService, $scope: ng.IScope, $rootScope: any, $timeout: ng.ITimeoutService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            private $translate: angular.translate.ITranslateService,
            private alertsLogService: Meevo.Plugins.AlertsLog.IAlertsLogService,
            private menuService: MenuService,
            private $document: ng.IDocumentService,
            private appSettings: Meevo.Components.Common.IAppSettings,
            private securityService: Meevo.Components.Common.ISecurityService,
            private $q: ng.IQService) {
            let convoBar = this;
            this.rootScope = $rootScope;
            this.scope = $scope;
            convoBar.convoService = convoService;
            convoBar.$timeout = $timeout;
            convoBar.debouncedHandler = this.cancellableDebounce(this.handleConvoInput, this.convoTimeout);
            this.isTrainingEnvironment = this.identityService.current().systemSettings.isTrainingEnvironment;
            this.isTestingEnvironement = this.identityService.current().systemSettings.isTestingEnvironment;
            this.inSandboxMode = this.identityService.current().systemSettings.isSandboxEnvironment;
            this.isMSIUser = this.identityService.current().userTypeEnum === Meevo.Model.UserTypeEnum.MSIUser;

            if (!$rootScope.$$listeners[Meevo.Components.Common.Messages.SYNCHRONIZE_CONVO]) {
                $rootScope.$on(Meevo.Components.Common.Messages.SYNCHRONIZE_CONVO, (event, contextItem) => {
                    var convoText = convoBar.convoService.getDefaultConvoForState(contextItem.name);
                    convoBar.convoInput = (contextItem.params || {})['convoInput'] || convoText;
                    convoBar.restingShortcut = convoBar.convoInput;
                    convoBar.isConvoInvalid = false;
                    convoBar.EmployeeDoesNotPerformService = false;
                    convoBar.suggestedCommands = null;
                });
            }

            if (!$rootScope.$$listeners[Meevo.Components.Common.Messages.CONVO_REQUESTED]) {
                $rootScope.$on(Meevo.Components.Common.Messages.CONVO_REQUESTED, (event, convo) => {
                    convoBar.convoInput = convo;
                    this.handleConvoInput();
                });
            }
            convoBar.isSingleLocation = this.identityService.current().isSingleLocation;
            convoBar.inCentralOfficeMode = this.identityService.inCentralOfficeMode();
            convoBar.inCallCenterMode = this.identityService.inCallCenterMode();
            convoBar.convoPlaceholder = "Tell Meevo what you want to do…";

            // Resolve the enhanced convobar placeholder via the async promise form so it stays
            // blank until the translation table is available, instead of briefly rendering the
            // raw key during bootstrap. Refresh on language change to keep it reactive.
            convoBar.loadEnhancedPlaceholder();
            $rootScope.$on('$translateChangeSuccess', () => convoBar.loadEnhancedPlaceholder());

            //this.getDatabaseTarget();

            this.dataService.customMethodData("api/Tenant/BusinessInfo/Settings", "get", {}).then((data) => {
                this.enableConvobarAppointmentSuggestions = data.data.appointmentBookSettings.enableConvobarAppointmentSuggestions;
            });

            this.loadAlertsCount();

            if (!this.isClickListenerAdded) {
                this.handleClickOutside = this.handleClickOutside.bind(this);
                $document.on('click', this.handleClickOutside);
                this.isClickListenerAdded = true;
            }

            this.scope.$on('$destroy', () => {
                $document.off('click', this.handleClickOutside);
            });

            this.securityService.checkSecurityKey(`${Meevo.Components.Common.SecurityKeys.REPORTS}${Meevo.Components.Common.SecurityParts.KEY_PART_READ}`)
                .then((access: Model.SecurityAccessEnum) => {
                if (access === Meevo.Model.SecurityAccessEnum.Grant) {
                    this.getReports();
                }
            });            
        }

        loadAlertsCount() {
            this.alertsLogService.updateAlertsCount();
        }

        selectText = function ($event) {
            $event.target.select();
        }

        unselectText = function () {
            var sel;
            if ((sel = document["selection"]) && sel.empty) {
                sel.empty();
            } else {
                if (window.getSelection) {
                    window.getSelection().removeAllRanges();
                }
                var activeEl = document.activeElement;
                if (activeEl) {
                    var tagName = activeEl.nodeName.toLowerCase();
                    if (tagName == "textarea" ||
                        (tagName == "input" && activeEl["type"] == "text")) {
                        // Collapse the selection to the end
                        activeEl["selectionStart"] = activeEl["selectionEnd"];
                    }
                }
            }
        }

        // Rule 3.1: default resting placeholder for the refreshed (enhanced) convobar.
        public getEnhancedPlaceholder(): string {
            return this.enhancedPlaceholder;
        }

        // Called via ng-init on the enhanced nav command row template. Checks whether a
        // multi-location-tenant user actually has access to more than one location; if not,
        // hides the switcher. Scoped to enhanced nav only so the legacy convobar is unaffected.
        public runLocationCheckForEnhancedNav(convoBar: any): void {
            if (convoBar.isSingleLocation) { return; }
            const identity = this.identityService.current();
            const cacheKey = `mil:meevo:location-count-check:${identity.tenantId}:${identity.locationId}:${identity.userName}`;
            const cached = sessionStorage.getItem(cacheKey);
            if (cached !== null) {
                convoBar.isSingleLocation = cached === 'single';
                return;
            }
            const locationCheckRequest: any = {
                pageNumber: 0,
                itemsPerPage: 2,
                criteria: {
                    filterBySessionUser: true,
                    locationStatus: [
                        Meevo.Model.LocationStatusEnum.Active,
                        Meevo.Model.LocationStatusEnum.ClosingPlanned,
                        Meevo.Model.LocationStatusEnum.TemporarilyClosed
                    ],
                    subscriptionStatus: [Meevo.Model.SubscriptionStatusEnum.Active],
                    filter: '%%'
                },
                includeActive: true,
                includeDeleted: false,
                includeInactive: false
            };
            this.dataService.getListPaged('changelocation', locationCheckRequest).then((locations: any[]) => {
                const isSingle = (locations || []).length <= 1;
                sessionStorage.setItem(cacheKey, isSingle ? 'single' : 'multi');
                if (isSingle) { convoBar.isSingleLocation = true; }
            }).catch(() => { /* keep switcher visible on error */ });
        }

        // Resolve the placeholder asynchronously. Using the promise form (rather than the
        // synchronous instant()) means it stays blank until the translation table loads,
        // so the raw key is never rendered during bootstrap.
        private loadEnhancedPlaceholder(): void {
            this.$translate('LABEL_CONVO_PLACEHOLDER').then((translated: string) => {
                this.enhancedPlaceholder = translated;
            });
        }

        // Rule 3.2 / 3.10: clear the active-area shortcut on focus so the user can type.
        public onEnhancedConvoFocus(): void {
            if (this.convoInput && this.convoInput === this.restingShortcut) {
                this.convoInput = '';
            }
        }

        // Rule 3.10: restore the active-area shortcut on blur when nothing was entered.
        public onEnhancedConvoBlur(): void {
            if (!this.convoInput && this.restingShortcut) {
                this.convoInput = this.restingShortcut;
            }
            this.unselectText();
        }
        //getDatabaseTarget() {
        //    this.dataService.customMethodData("api/DatabaseTarget", "get", null).then((data) => {
        //        if (data.data == "Sandbox") {
        //            this.inSandboxMode = true;
        //        }
        //    });
        //}

        checkIfEnterKeyWasPressed = function ($event) {
            this.isConvoInvalid = false;
            if (this.convoInput && this.convoInput.length < 2)
              return;
            var keyCode = $event.which || $event.keyCode;
            if (keyCode === 13) {
                var inputElement = $event.target;
                var cursorPosition = inputElement.selectionStart;                
                this.modalService.hide();
                clearTimeout(this.debouncedHandler().timeout);
                this.handleConvoInput().then(() => {
                    if (inputElement && inputElement.value && cursorPosition <= inputElement.value.length) {
                        inputElement.focus();
                        inputElement.setSelectionRange(cursorPosition, cursorPosition);
                    }
                });
            }
        }

        getReports(): void {
            this.dataService.getListPaged(this.appSettings.API_ENDPOINTS.report, {
                criteria: { objectStateEnum: Meevo.Model.ObjectStateEnum.Active }
            }).then((reports: Meevo.Model.IReport[]) => {
                this.reportList = reports;
            });
        }

        handleConvoInput() {
            this.isConvoPending = true;
            this.suggestedCommands = null;
            this.isConvoInvalid = false;
            return this.convoService.resolveConvoInput(this.convoInput).then((result: ConvoResult) => {
                // TODO: Visual handling of resolved versus unresolved
                this.isConvoPending = false;
                this.EmployeeDoesNotPerformService = false;
                this.isConvoInvalid = result.status == ConvoStatus.Unresolved;
                let convoError: ConvoError;
                if (Model.Guard.isSomething(result.security) && result.security.module !== Model.SecurityAccessEnum.Grant) {
                    convoError = ConvoError.NotEnabled;
                } else if (result.isInCallCenterAndRouteBlocked) {
                    convoError = ConvoError.NotAvailableInCallCenter;
                } else if (Model.Guard.isSomething(result.security) && result.security.availabilityLevel !== Model.SecurityAccessEnum.Grant) {
                    if (this.identityService.inCentralOfficeMode()) {
                        convoError = ConvoError.NotAvailableInCO;
                    } else if (this.identityService.current().isSingleLocation) {
                        convoError = ConvoError.NotAvailable;
                    } else {
                        convoError = ConvoError.OnlyAvailableInCO;
                    }
                }
                let errorHttp403 = Model.Guard.isSomething(convoError) ? "ERROR_HTTP_403_" + ConvoError[convoError].toUpperCase() : "ERROR_HTTP_403";

                if (result.status == ConvoStatus.NoAccess) {
                    if (errorHttp403=="ERROR_HTTP_403"){
                    errorHttp403 = this.$translate.instant(errorHttp403);
                    errorHttp403 = errorHttp403 + "</br> " + result.security.securityKeyPath;
                    }
                    this.modalService.alert(errorHttp403);
                }
                if (result.status == ConvoStatus.ResolvedWithNoAction) {
                    this.convoInput = "";
                }

                if (result.employeeDoNotPerformServicesList != null && result.employeeDoNotPerformServicesList.length > 0) {
                    this.EmployeeDoesNotPerformService = true;
                    this.EmployeeDoesNotPerformServiceMessage = result.employeeDoNotPerformServicesList;
                }

                const seenLabels = new Set<string>();
                if (result.suggestedCommands && typeof result.suggestedCommands[Symbol.iterator] === 'function') {
                    this.$q.all(result.suggestedCommands.map(suggestion => this.getCommandMenuData(suggestion)))
                        .then(items => {
                            this.suggestedCommands = [];
                            items.forEach((item, idx) => {
                                if (item && !seenLabels.has(item.label)) {
                                    seenLabels.add(item.label);
                                    this.suggestedCommands.push({
                                        icon: item.icon,
                                        command: result.suggestedCommands[idx].command,
                                        label: item.label,
                                        isReport: result.suggestedCommands[idx].isReport
                                    });
                                }
                            });
                            this.scope.$applyAsync();
                        });
                }

                this.embeddings = result.embeddings || [];

                if (result.isBrowserTab) {
                    this.clear();
                }

                if (result.status == ConvoStatus.Resolved && !this.suggestedCommands) {
                    //removes menu on correct search
                    this.rootScope.displayDropdownFunction();
                }

                if (!this.isConvoInvalid) {
                    $('#convobarInput').blur(); // hides mobile keyboard    
                }
                
            }).catch(() => {
                // TODO: Review how to handle promise rejections here. The promise won't resolve if a new convo request
                // came in before we handled the old one.
            }).finally(() => {               
                this.debouncedHandler = this.cancellableDebounce(this.handleConvoInput, this.convoTimeout);
            });
        }

        cancellableDebounce = function (func, wait, immediate?) {
            var timeout, args, context, timestamp, result;
            var later = function () {
                var last = _.now() - timestamp;
                if (last < wait && last >= 0) {
                    timeout = setTimeout(later, wait - last);
                } else {
                    timeout = null;
                    if (!immediate) {
                        result = func.apply(context, args);
                        if (!timeout) context = args = null;
                    }
                }
            };

            return function () {
                context = this;
                args = arguments;
                timestamp = _.now();
                var callNow = immediate && !timeout;
                if (!timeout) timeout = setTimeout(later, wait);
                if (callNow) {
                    result = func.apply(context, args);
                    context = args = null;
                }
                // Return timeout so debounced function can be cancelled
                result = result || {};
                result.timeout = timeout;
                return result;
            };
        }

        public clear(): void {
          this.convoInput = '';
          this.suggestedCommands = null;
          setTimeout(() => {
            $('input#convobarInput').focus();
          }, 1);
        }

        public suggestionSelected(item: ISuggestedConvoCommand): void {
            this.convoInput = item.command;
            this.suggestedCommands = null;
            this.handleConvoInput();
        }

        public getCommandMenuData(suggestion: ISuggestedConvoCommand): ng.IPromise<{ icon: string, label: string } | null> {
            const item = this.convoService.convoMap[suggestion.command];
            const menuItems = this.menuService.menuItems;

            const getMenuData = (route: string, fallbackIcon = 'ai-chat') => {
                for (const menuItem of menuItems) {
                    for (const subMenuItem of menuItem.subMenuItems) {
                        if (subMenuItem.stateName === route) {
                            return {
                                icon: subMenuItem.icon || fallbackIcon,
                                label: subMenuItem.contentKey || ''
                            };
                        }
                    }
                }
                return null;
            };

            if (item) {
                if (item.securityKey) {
                    let key = item.securityKey + Meevo.Components.Common.SecurityParts.KEY_PART_READ;
                    return this.securityService.checkSecurityKey(key.toString())
                        .then(access =>
                            access === Meevo.Model.SecurityAccessEnum.Grant
                                ? getMenuData(item.route)
                                : null
                        );
                } else {
                    const data = getMenuData(item.route);
                    return this.$timeout(() => data, 0);
                }
            }

            const matchingReport = this.reportList.find(x => x.shortCut.toLowerCase() === suggestion.command.toLowerCase());
            if (matchingReport) {
                return this.securityService.checkSecurityKey(matchingReport.securityKey)
                    .then(access => {
                        if (access === Meevo.Model.SecurityAccessEnum.Grant) {
                            const foundMenu = menuItems.find(x => x.id === Meevo.Components.Common.SecurityKeys.REPORTS);
                            const reportMenuItem = foundMenu && foundMenu.subMenuItems ? foundMenu.subMenuItems : [];
                            const subMenuItem = reportMenuItem.find(x => x.stateParams.categoryId === matchingReport.reportCatId);
                            const menuData = subMenuItem
                                ? { icon: subMenuItem.icon || 'meevo_reports_analytical', label: matchingReport.shortCut + ': ' + matchingReport.displayName }
                                : { icon: 'meevo_reports_analytical', label: matchingReport.shortCut + ': ' + matchingReport.displayName };
                            return menuData;
                        }
                        return null;
                    });
            }

            return this.$timeout(() => null, 0);
        }

        public convoAiChatSelected(): void {
            this.suggestedCommands = null;
            this.rootScope.$broadcast(Meevo.Components.Common.Messages.RESTART_AICHAT, null);
            sessionStorage.setItem("mil:meevo:convoinput", this.convoInput || '');
            if (this.embeddings && this.embeddings.length > 0) {
                sessionStorage.setItem("mil:meevo:convoembeddings", JSON.stringify(this.embeddings));
            }
        }

        public getFlashColor(): string {
            let color = angular.element('.context-active').css('background-color');
            return color;
        }

        private handleClickOutside(event): void {
            this.isConvoInvalid = false;
            let target = event.target;
            let isClickInside = target.closest('.convobar-ai-suggestion-container');
            if (!isClickInside) {
                this.scope.$apply(() => {
                    this.suggestedCommands = null;
                });
            }
        }

    }

    // controller registration with module
    angular.module("meevo")
        .controller("meevo.convo.ConvoBarController",
        ConvoBarController);
}
